module.exports = __webpack_public_path__ + "img/01_body_1210_rough.19a0a9b2.png";